import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import MarketsNews from './markets-news';

const MarketsNewsWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <MarketsNews />
    </QueryClientProvider>
  );
};

export { MarketsNewsWidget }
